/*
  Avyanna newsletter search cards (3 Nov 2026).
  Shows group orders, events and launches from the Newsletter page (not pre-orders)
  when someone searches for them, in the search dropdown and on the search page.
  It reads the Newsletter page itself, so anything added there shows up here
  with no extra setup. Small typos are forgiven ("hobinichi" finds Hobonichi).
  The page is read once and kept for 10 minutes per visit.
*/
(function () {
  'use strict';

  var root = document.currentScript;
  var NL_URL = (root && root.dataset.url) || '/pages/newsletter';
  var KEY = 'avyNlIndex:v3';
  var TTL = 10 * 60 * 1000;
  var MAX_DROPDOWN = 3;
  var MAX_PAGE = 6;

  var GROUPS = [
    ['g-go', 'Group order', 'group order groupbuy'],
    ['g-ev', 'Event', 'event events meetup workshop'],
    ['g-la', 'Launch', 'launch launches collab']
  ];

  /* ---------- reading the Newsletter page ---------- */

  function clean(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  function words(s) {
    return clean(s)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .split(/[^a-z0-9]+/)
      .filter(Boolean);
  }

  function deepText(el) {
    if (!el) return '';
    var parts = [];
    (function walk(n) {
      n.childNodes.forEach(function (c) {
        if (c.nodeType === 3) parts.push(c.nodeValue);
        else if (c.nodeType === 1) { parts.push(' '); walk(c); parts.push(' '); }
      });
    })(el);
    return clean(parts.join('')).replace(/\s+([,.])/g, '$1');
  }

  function short(s, n) {
    s = clean(s);
    return s.length > n ? s.slice(0, n - 1).replace(/\s+\S*$/, '') + '…' : s;
  }

  function firstImage(el) {
    var img = el.querySelector('img');
    if (!img) return '';
    var src = img.getAttribute('src') || '';
    return src.replace(/([?&])width=\d+/, '$1width=160');
  }

  function textLink(title) {
    return NL_URL + '#:~:text=' + encodeURIComponent(title);
  }

  function readItems(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var out = [];
    var seen = {};
    var groups = doc.querySelectorAll('.anl-grp:not(.anl-grp--pin):not(.anl-arc)');

    groups.forEach(function (grp) {
      var g = null;
      for (var i = 0; i < GROUPS.length; i++) {
        if (grp.classList.contains(GROUPS[i][0])) {
          g = GROUPS[i];
          break;
        }
      }
      if (!g) return;

      var nodes = grp.querySelectorAll('.anl-go, .anl-ev, .anl-card, .anl-row, .anl-cl, .anl-pst > li');
      nodes.forEach(function (el) {
        var tEl = el.querySelector('.anl-go__t, .anl-ev__t, .anl-t');
        var title = clean(tEl && tEl.textContent);
        if (!title) return;

        var type = g[1];
        var past = false;
        if (el.classList.contains('anl-cl')) {
          type = 'Pre-order';
          past = true;
        }
        if (el.closest('.anl-pst')) past = true;

        var tag = deepText(el.querySelector('.anl-tag'));
        var meta = deepText(el.querySelector('.anl-m, .anl-go__d'));
        if (el.classList.contains('anl-row')) tag = 'Opening soon';
        if (/^closed/i.test(tag) || /recap/i.test(meta)) past = true;

        var status = tag;
        if (meta && meta !== tag) status = status ? status + ' · ' + meta : meta;
        if (!status && el.classList.contains('anl-cl')) status = 'Closed';
        status = short(status.replace(/\s*·\s*Recap\s*→?\s*$/i, '').replace(/\s*→\s*$/, ''), 72);

        var url = '';
        if (type === 'Group order') {
          url = textLink(title);
        } else {
          var a = tEl && tEl.querySelector('a[href]');
          if (!a) a = el.matches('a[href]') ? el : el.querySelector('a[href]');
          url = a ? a.getAttribute('href') : textLink(title);
        }

        var id = type + '|' + title;
        if (seen[id]) return;
        seen[id] = true;

        var place = '';
        if (type === 'Event') place = meta.split('·').slice(1).join(' ');

        out.push({
          type: type,
          title: title,
          status: status,
          url: url,
          img: firstImage(el),
          past: past,
          tw: words(title),
          kw: words(g[2] + ' ' + type + ' ' + place)
        });
      });
    });
    return out;
  }

  var pending = null;
  function getItems() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < TTL && Array.isArray(c.items)) return Promise.resolve(c.items);
    } catch (e) {}
    if (pending) return pending;
    pending = fetch(NL_URL, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        var items = html ? readItems(html) : [];
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items }));
        } catch (e) {}
        return items;
      })
      .catch(function () {
        return [];
      })
      .finally(function () {
        pending = null;
      });
    return pending;
  }

  /* ---------- matching (forgives small typos) ---------- */

  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var prev = [], cur = [];
    for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur.slice();
    }
    return prev[n];
  }

  function wordHit(q, w, fuzzy) {
    if (w.indexOf(q) === 0) return true;
    if (!fuzzy || q.length < 5) return false;
    var allow = q.length >= 8 ? 2 : 1;
    if (lev(q, w) <= allow) return true;
    if (w.length > q.length && lev(q, w.slice(0, q.length)) <= 1) return true;
    return false;
  }

  function score(item, qs) {
    var total = 0;
    for (var i = 0; i < qs.length; i++) {
      var q = qs[i];
      var best = 0;
      for (var a = 0; a < item.tw.length; a++) {
        if (item.tw[a].indexOf(q) === 0) { best = 3; break; }
        if (wordHit(q, item.tw[a], true)) best = Math.max(best, 2);
      }
      if (!best) {
        for (var b = 0; b < item.kw.length; b++) {
          if (wordHit(q, item.kw[b], false)) { best = 1; break; }
        }
      }
      if (!best) return 0;
      total += best;
    }
    return total;
  }

  function match(items, query) {
    var raw = clean(query);
    if (raw.length < 3) return [];
    var qs = words(raw).filter(function (w) { return w.length >= 2 || /\d/.test(w); });
    if (!qs.length) return [];
    return items
      .map(function (it) { return { it: it, s: score(it, qs) }; })
      .filter(function (x) { return x.s > 0; })
      .sort(function (a, b) {
        if (a.it.past !== b.it.past) return a.it.past ? 1 : -1;
        return b.s - a.s;
      })
      .map(function (x) { return x.it; });
  }

  /* ---------- drawing the cards ---------- */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addStyles() {
    if (document.getElementById('avy-nlpin-css')) return;
    var st = document.createElement('style');
    st.id = 'avy-nlpin-css';
    st.textContent = [
      '.avy-nlpin{margin:0 0 4px;padding:0;list-style:none}',
      '.avy-nlpin a{display:flex;align-items:center;gap:12px;padding:10px;border-radius:12px;color:inherit;text-decoration:none}',
      '.avy-nlpin a:hover,.avy-nlpin a:focus-visible{background:rgb(var(--color-foreground-rgb) / .06)}',
      '.avy-nlpin .im{flex:none;width:56px;height:56px;border-radius:8px;object-fit:cover;background:#f6f2ec}',
      '.avy-nlpin b{display:block;font-weight:500;line-height:1.3}',
      '.avy-nlpin small{display:block;margin-top:2px;opacity:.7;line-height:1.3}',
      '.avy-nlpin .k{display:block;font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;opacity:.65;line-height:1.3}',
      '.avy-nlpin-p{box-sizing:border-box;width:100%;max-width:1600px;margin:16px auto 0;padding:0 20px;display:grid;gap:10px;grid-template-columns:repeat(auto-fill,minmax(min(100%,440px),1fr))}',
      '.avy-nlpin-p a{display:flex;align-items:center;gap:16px;padding:14px;border:1px solid rgb(var(--color-foreground-rgb) / .12);border-radius:16px;color:inherit;text-decoration:none}',
      '.avy-nlpin-p a:hover{border-color:rgb(var(--color-foreground-rgb) / .3)}',
      '.avy-nlpin-p .im{flex:none;width:88px;height:88px;border-radius:12px;object-fit:cover;background:#f6f2ec}',
      '.avy-nlpin-p .k{display:block;font-size:11px;letter-spacing:.12em;text-transform:uppercase;opacity:.65}',
      '.avy-nlpin-p b{display:block;margin-top:2px;font-size:17px;font-weight:500;line-height:1.3}',
      '.avy-nlpin-p .d{display:block;margin-top:2px;font-size:14px;opacity:.75}',
      '.avy-nlpin-p .v{margin-left:auto;flex:none;font-size:14px;white-space:nowrap}',
      '@media (min-width:750px){.avy-nlpin-p{padding:0 32px}}'
    ].join('');
    document.head.appendChild(st);
  }

  function pic(it) {
    return it.img
      ? '<img class="im" src="' + esc(it.img) + '" alt="" width="56" height="56" loading="lazy">'
      : '<span class="im" aria-hidden="true"></span>';
  }

  function dropdownHtml(list) {
    return (
      '<ul class="avy-nlpin list-unstyled" aria-label="From the newsletter">' +
      list
        .map(function (it) {
          return (
            '<li><a href="' + esc(it.url) + '">' + pic(it) +
            '<span><span class="k">' + esc(it.type) + '</span><b>' + esc(it.title) + '</b>' +
            (it.status ? '<small>' + esc(it.status) + '</small>' : '') +
            '</span></a></li>'
          );
        })
        .join('') +
      '</ul>'
    );
  }

  function pageHtml(list) {
    return (
      '<div class="avy-nlpin-p" aria-label="From the newsletter">' +
      list
        .map(function (it) {
          return (
            '<a href="' + esc(it.url) + '">' + pic(it).replace(/width="56" height="56"/, 'width="88" height="88"') +
            '<span><span class="k">' + esc(it.type) + '</span><b>' + esc(it.title) + '</b>' +
            (it.status ? '<span class="d">' + esc(it.status) + '</span>' : '') +
            '</span><span class="v" aria-hidden="true">View →</span></a>'
          );
        })
        .join('') +
      '</div>'
    );
  }

  /* ---------- search dropdown ---------- */

  function queryFor(box) {
    var scope = box.closest('predictive-search-component, dialog, .search-modal, form, .shopify-section') || document;
    var input = scope.querySelector('input[name="q"]');
    if (!input || !input.value) {
      var all = document.querySelectorAll('input[name="q"]');
      for (var i = 0; i < all.length; i++) if (all[i].value) { input = all[i]; break; }
    }
    return input ? input.value : '';
  }

  var busy = false;
  function fillDropdown(box) {
    var q = queryFor(box);
    var old = box.querySelector('.avy-nlpin');
    if (box.dataset.avyNlQ === q && old) return;
    box.dataset.avyNlQ = q;
    if (old) old.remove();
    if (clean(q).length < 3) return;

    getItems().then(function (items) {
      if (queryFor(box) !== q || !box.isConnected) return;
      var hits = match(items, q).slice(0, MAX_DROPDOWN);
      var prev = box.querySelector('.avy-nlpin');
      if (prev) prev.remove();
      if (!hits.length) return;
      addStyles();
      busy = true;
      var anchor = box.querySelector('.avy-mcpin') || box.querySelector('.predictive-search-results__wrapper-queries');
      if (anchor) anchor.insertAdjacentHTML('afterend', dropdownHtml(hits));
      else box.insertAdjacentHTML('afterbegin', dropdownHtml(hits));
      var none = box.querySelector('.predictive-search-results__no-results');
      if (none) none.hidden = true;
      busy = false;
    });
  }

  function scan() {
    document.querySelectorAll('[data-search-results]').forEach(fillDropdown);
  }

  var timer = null;
  new MutationObserver(function () {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(scan, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.name === 'q') getItems();
  });

  /* ---------- search results page ---------- */

  function fillPage() {
    var main = document.getElementById('MainContent');
    if (!main || main.dataset.template !== 'search') return;
    var q = new URLSearchParams(location.search).get('q') || '';
    if (clean(q).length < 3) return;
    getItems().then(function (items) {
      var hits = match(items, q).slice(0, MAX_PAGE);
      if (!hits.length || document.querySelector('.avy-nlpin-p')) return;
      addStyles();
      var acs = main.querySelector('.acs');
      var sec = acs ? acs.closest('.shopify-section') : null;
      if (sec) sec.insertAdjacentHTML('beforebegin', pageHtml(hits));
      else main.insertAdjacentHTML('afterbegin', pageHtml(hits));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillPage);
  else fillPage();

  window.AvyNewsletterSearch = { match: function (q) { return getItems().then(function (i) { return match(i, q); }); } };
})();
